<template>
    <section>
        <HomeTopComponent/>
        <!-- <HomeTop/> -->
        <HeartCenter/>
        <HomeDirectorComponent/>
        <HomeFacilityComponent/>
        <!-- <HomeTextComponent/> -->
        <!-- <ArticleSection/> -->
    </section>
</template>

<script setup>
    import HomeTopComponent from '../components/home/HomeTopComponent.vue';
    // import HomeTop from '../components/home/HomeTop.vue';
    import HeartCenter from '../components/home/HeartCenter.vue';
    import HomeDirectorComponent from '../components/home/HomeDirectorComponent.vue';
    import HomeFacilityComponent from '../components/home/HomeFacilityComponent.vue';
    // import HomeTextComponent from '../components/home/HomeTextComponent.vue';
    // import ArticleSection from '../components/home/ArticleSection.vue';
    window.scrollTo(0, 0);
</script>

<style scoped>
    /*  */
</style>